module.exports = __webpack_public_path__ + "img/131.fd1a0ca8.jpg";